// Dummy interface with the bare minimum functionality until LiveInputs is ported to TS fully
export interface LiveInputs {
  completeInitialization: () => void
  initAsyncRendering: () => Promise<void>
  on: (
    event: string,
    selector: string,
    callback: (event: Event) => void
  ) => void
  off: (
    event: string,
    selector: string,
    callback: (event: Event) => void
  ) => void
  supportsAsyncTemplateRendering: () => boolean | undefined
  teardown: () => void
  update: (
    target: JQuery<HTMLElement>,
    options?: Record<string, unknown>
  ) => void
  setTabDirection(direction: number): void
}

export interface LiveInputsPostLinkInterface {
  teardown(): void
}

export type SaveButtonState =
  | 'disabled'
  | 'hidden'
  | 'save'
  | 'saving'
  | 'saved'
  | 'failed'

export const SaveChangesStatuses = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  ERROR: 'error',
} as const

export type SaveChangesStatus =
  typeof SaveChangesStatuses[keyof typeof SaveChangesStatuses]

export type ExternalLinkAttributes = {
  name: string
  url: string
  id: string
}
